
  import { defineComponent } from 'vue';
  import { useDetailedViewStore } from '@/stores/analytics/detailedView';
  import { ReportWidget } from '@/services/api/resources/analytics-builder/model';
  import { useDetailedView } from '@/ui/concerns/analytics/useDetailedView';
  import { useReportInjection } from '@/ui/concerns/analytics/useReportInjection';

  interface SingleNumberProps {
    value: number | string;
    text: string;
    widget: ReportWidget;
  }

  export default defineComponent<SingleNumberProps>({
    props: ['value', 'text', 'widget'],
    emits: ['detailed-view-open'],
    setup(props, { emit }) {
      const { isGuest, reportId, report } = useReportInjection();
      const store = useDetailedViewStore();
      const { getDetailedViewType } = useDetailedView();

      const onClick = () => {
        if (isGuest) {
          return;
        }

        if (!(report.value && props.widget.metric)) {
          return;
        }

        store.setDetailedView({
          reportId: reportId.value ?? undefined,
          report: report.value,
          resourceId: undefined,
          widgetKey: props.widget.key,
          detailedViewType: getDetailedViewType(props.widget.metric),
          options: {},
        });
        emit('detailed-view-open');
      };

      return {
        onClick,
      };
    },
  });
